import React from 'react';
import ReactPlayer from '../../../../components/ReactPlayer';

import '../style.scss';

const ParagraphVideoGetStarted = ({ entity }) => {

  const remoteVideo = entity.getIn(['field_video_media', 0, 'source'], entity.getIn(['field_video_media', 0, 'embed']));
  const autoplay = entity.getIn(['field_video_autoplay', 0, 'value'], '');
  const controls = entity.getIn(['field_video_controls', 0, 'value'], '');
  const loop = entity.getIn(['field_video_loop', 0, 'value'], '');
  const poster = entity.getIn(['field_poster', 0, 'styles', 'paragraph_image']);
  const caption = entity.getIn(['field_caption', 0, 'value'], '');

  return remoteVideo && (
    <div className="Paragraph ParagraphVideo__Wrapper">
      <ReactPlayer
        url={remoteVideo}
        width="100%"
        height="100%"
        className="ParagraphVideo__video"
        loop={loop}
        controls={controls}
        light={poster}
        playing={autoplay}
        playIcon={<span className="ParagraphVideo__video__poster icon icon-play icon-variant-2" />}
      />
      {caption && <p className="ParagraphVideo__caption">{caption}</p>}
    </div>
  );
};

export default ParagraphVideoGetStarted;
